export const EDURECS = {
  FETCH: 'FETCH_EDURECS',
  FETCH_COMPLETED: 'FETCH_EDURECS_COMPLETED',
  FETCH_CRIT: 'FETCH_CRIT_EDURECS',
  FETCH_CRIT_COMPLETED: 'FETCH_CRIT_EDURECS_COMPLETED',
  SELECT_ACYEAR: 'SELECT_ACYEAR',
};

export const EDUREC = {
  FETCH: 'FETCH_EDUREC',
  FETCH_COMPLETED: 'FETCH_EDUREC_COMPLETED',
  CREATE: 'CREATE_REGISTRY',
  CREATE_COMPLETED: 'CREATE_REGISTRY_COMPLETED',
  CLOSE: 'CLOSE_REGISTRY',
  CLOSE_COMPLETED: 'CLOSE_REGISTRY_COMPLETED',
  OPEN: 'OPEN_REGISTRY',
  OPEN_COMPLETED: 'OPEN_REGISTRY_COMPLETED',
  DELETE: 'DELETE_REGISTRY',
  DELETE_COMPLETED: 'DELETE_REGISTRY_COMPLETED',
  UPDATING_ABSENCES: 'UPDATING_ABSENCES',
  UPDATING_ABSENCES_COMPLETED: 'UPDATING_ABSENCES_COMPLETED',
  UPDATING_NOTES: 'UPDATING_NOTES',
  UPDATING_NOTES_COMPLETED: 'UPDATING_NOTES_COMPLETED',
  FETCH_PROGRAM: 'FETCH_PROGRAM',
  FETCH_PROGRAM_COMPLETED: 'FETCH_PROGRAM_COMPLETED',
};

export const OCCURRENCES = {
  FETCH: 'FETCH_OCCURRENCES',
  FETCH_COMPLETED: 'FETCH_OCCURRENCES_COMPLETED',
  CREATE: 'INSERTING_ACTIVITIES',
  CREATE_COMPLETED: 'INSERTING_ACTIVITIES_COMPLETED',
  DELETE: 'REMOVING_ACTIVITIES',
  DELETE_COMPLETED: 'REMOVING_ACTIVITIES_COMPLETED',
  UPDATE: 'UPDATING_ACTIVITIES',
  UPDATE_COMPLETED: 'UPDATING_ACTIVITIES_COMPLETED',
};

export const TRASVERSAL = {
  FETCH: 'FETCH_TRASVERSAL',
  FETCH_COMPLETED: 'FETCH_TRASVERSAL_COMPLETED',
  CREATE: 'CREATE_TRASVERSAL',
  CREATE_COMPLETED: 'CREATE_TRASVERSAL_COMPLETED',
  OPEN: 'OPEN_TRASVERSAL',
  OPEN_COMPLETED: 'OPEN_TRASVERSAL_COMPLETED',
  CLOSE: 'CLOSE_TRASVERSAL',
  CLOSE_COMPLETED: 'CLOSE_TRASVERSAL_COMPLETED',
  DELETE: 'DELETE_TRASVERSAL',
  DELETE_COMPLETED: 'DELETE_TRASVERSAL_COMPLETED',
  UPDATING_NOTES: 'UPDATING_TRASVERSAL_NOTES',
  UPDATING_NOTES_COMPLETED: 'UPDATING_TRASVERSAL_NOTES_COMPLETED',
  LOAD: 'LOAD_TRASVERSAL_COMPLETED',
  FETCH_FORMEDID: 'FETCH_FORMEDID_COMPLETED',
};

export const TRAS_OCCURRENCES = {
  FETCH: 'FETCH_TRAS_OCCURRENCES',
  FETCH_COMPLETED: 'FETCH_TRAS_OCCURRENCES_COMPLETED',
  CREATE: 'CREATE_TRAS_OCCURRENCES',
  CREATE_COMPLETED: 'CREATE_TRAS_OCCURRENCES_COMPLETED',
  DELETE: 'DELETE_TRAS_OCCURRENCES',
  DELETE_COMPLETED: 'DELETE_TRAS_OCCURRENCES_COMPLETED',
  UPDATE: 'UPDATE_TRAS_OCCURRENCES',
  UPDATE_COMPLETED: 'UPDATE_TRAS_OCCURRENCES_COMPLETED',
};

export const USER = {
  FETCH: 'FETCH_USERINFO',
  FETCH_COMPLETED: 'FETCH_USERINFO_COMPLETED',
  CHANGE: 'CHANGE_USERINFO',
  NOT_AUTHENTICATED: 'USER_NOT_AUTHENTICATED',
};

